import type { IThreshold, TUpdateThreshold } from '@web/entities/threshold'
import { ApiResource, ApiTag } from '@web/shared/constants/api.constants'
import { baseApi } from '@web/shared/infrastructure/api-base-query'
import type { TId } from '@web/shared/types/id.type'

export const thresholdApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getThreshold: builder.query<IThreshold, TId>({
      query: (mpId) => ({
        url: `${ApiResource.Measurements}/${mpId}/threshold`
      }),
      providesTags: [ApiTag.Threshold]
    }),

    updateThreshold: builder.mutation<
      { id: TId },
      {
        thresholdData: TUpdateThreshold
        measurementId: string
      }
    >({
      query: (requestData) => ({
        url: `${ApiResource.Measurements}/${requestData.measurementId}/threshold`,
        method: 'PUT',
        body: requestData.thresholdData
      }),
      invalidatesTags: [ApiTag.Threshold]
    }),

    enableThreshold: builder.mutation<
      void,
      Pick<IThreshold, 'controlEnabled'> & { id: TId }
    >({
      query: ({ id, controlEnabled }) => ({
        url: `${ApiResource.Measurements}/${id}/threshold/enabled`,
        method: 'PUT',
        body: {
          controlEnabled
        }
      }),
      invalidatesTags: [ApiTag.Threshold]
    })
  })
})

export const {
  useGetThresholdQuery,
  useUpdateThresholdMutation,
  useEnableThresholdMutation
} = thresholdApi
